function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesLuggageFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.615 18.539h12.771V9.426H9.616v9.113zm0 7h12.771v-5H9.616v5zM23.386 7.426H17v-3.35h2.257v-2h-6.514v2H15v3.35H8.614a1 1 0 00-1 1v18.113a1 1 0 001 1h2v2.46h2v-2.46h6.772v2.46h2v-2.46h2a1 1 0 001-1V8.426a1 1 0 00-1-1z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesLuggageFilled;